// extracted by mini-css-extract-plugin
export default {"loginLogo":"login_loginLogo__UvOD6","loginWrapper":"login_loginWrapper__4PJdQ"};